// extracted by mini-css-extract-plugin
export default {"tableTableView":"TableView_tableTableView__COuSm","divColumnHeaderWithTooltip":"TableView_divColumnHeaderWithTooltip__gKxg+","tooltiptext":"TableView_tooltiptext__DohL4"};